import React from 'react'
import { useRouter } from 'next/router'
import { Work } from '@prisma/client'

import Layout from '../../components/Layout'
import { WorkListItem } from '../../components/WorkListItem'
import { useExhibition } from '../../lib/apiClient'

const Exhibition: React.FC = () => {
  const router = useRouter()
  const { id } = router.query
  const {
    data: exhibition, isError, isLoading, error,
  } = useExhibition(Number(id))
  const numWorks = !isError && exhibition && exhibition.works && exhibition.works.length
  const workLabel = exhibition?.workLabel || 'work'
  return (
    <Layout exhibition={exhibition} exhibitionIsLoading={isLoading}>
      {isLoading && <p>Loading...</p>}
      {isError && <p>{error?.message || 'Error!'}</p>}
      {
        !isLoading && !isError && (
          <div className="exhibition">
            {exhibition.secondaryImageUrl && (
              // eslint-disable-next-line
              <img
                src={exhibition.secondaryImageUrl}
                alt={exhibition.secondaryImageAltText || exhibition.name}
              />
            )}
            <p className="descriptive-header body-font-size-medium">
              {`${numWorks} ${workLabel}${workLabel && numWorks !== 1 ? 's' : ''}`}
            </p>
            {
              exhibition.works?.map((work: Work) => (
                <WorkListItem
                  key={work.id}
                  work={work}
                />
              ))
            }
          </div>
        )
      }
    </Layout>
  )
}

export default Exhibition
